import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AbstractService } from './abstract.service';
import { environment } from 'environments/environment';
import { Cliente } from 'app/dto/cliente.dto';
import { Page } from "app/dto/page.dto";
import { map } from "rxjs/operators";
import { Funcion } from "app/dto/funcion.dto";

@Injectable({
  providedIn: 'root'
})
export class FuncionService extends AbstractService<Funcion>{
  constructor(http: HttpClient) {
    super(http, environment.url_backend + 'funcion');
  }

  paginado(page: number, size: number, idTipoFuncion: string, nombre: string) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("page", page.toString());
    httpParams = httpParams.set("size", size.toString());
    httpParams = httpParams.set("relations", "@aplicacion()@tipoFuncion()");

    if (idTipoFuncion) {
      httpParams = httpParams.set("idTipoFuncion", idTipoFuncion.toString());
    }
    if (nombre) {
      httpParams = httpParams.set("nombre", nombre.trim());
    }
    return this.http.get<Page>(this.urlServicio + "/paginado", { params: httpParams });
  }

}
